import ErrorScreen from 'src/components/ErrorScreen'

const EmptyRegistration = ({
  errorMessage,
  title = 'SOMETHING WENT WRONG',
}: {
  errorMessage: string
  title?: string
}) => {
  return (
    <ErrorScreen
      title={title}
      message={errorMessage || 'Please try again.'}
      onButtonPress={() => {
        window.location.href = '/'
      }}
    />
  )
}

export default EmptyRegistration
